<template>
  <v-form ref="form" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-card color="kbWhite">
            <v-card-title>
                <h4 class="kbDarkBlueText--text text-capitalize ml-2">{{$t('general.newBusiness')}}</h4>
            </v-card-title>
            <v-card-text>
                <v-col cols="12">
                    <v-text-field :label="$t('general.nameOfTheBusiness')"
                                  color="kbDarkBlueText"
                                  v-model="name"
                                  :rules="[rules.required]">
                    </v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field :label="$t('general.phone')"
                                  color="kbDarkBlueText"
                                  v-model="phone">
                    </v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field :label="$t('general.email')"
                                  color="kbDarkBlueText"
                                  v-model="email">
                    </v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field :label="$t('general.address')"
                                  color="kbDarkBlueText"
                                  v-model="address">
                    </v-text-field>
                </v-col>

                <v-col cols="12">
                    <v-text-field :label="$t('general.webSiteUrl')"
                                  color="kbDarkBlueText"
                                  v-model="url">
                    </v-text-field>
                </v-col>

                <v-col cols="12" class="d-flex justify-end">
                    <v-btn color="kbBlue"
                           dark
                           @click="submit"
                           :loading="creatingCompany">{{$t('general.saveNewBusiness')}}</v-btn>
                </v-col>
            </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  data () {
    return {
      creatingCompany: false,
      name: '',
      phone: '',
      email: '',
      address: '',
      url: '',
      rules: rules
    }
  },
  methods: {
    async submit () {
      try {
        if (!this.$refs.form.validate()) return

        this.creatingCompany = true
        const data = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          address: this.address,
          url: this.url
        }

        await this.$store.dispatch('createCompany', data)

        notifications.success(this.$t('general.businessSuccessfullyCreated', { business: this.businessModule.s }))
        this.creatingCompany = false
        await this.$router.push('/home')
      } catch (e) {
        console.error(e)
        this.creatingCompany = false
      }
    }
  }
}
</script>
